module.exports = __webpack_public_path__ + "images/emoji/arrow_up.ec8c519053bf7102162d.png";